module.exports = __webpack_public_path__ + "img/H14-5.png";